import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NiceModal from '@ebay/nice-modal-react';
import { Badge, Divider, IconButton, MenuItem, MenuList, Popover, Tooltip, Typography } from '@mui/material';
import { UserContext } from 'common/context/UserContext';
import ClientIcon from 'common/components/Icons/v2/Client';
import CreateAddClientModal from 'components/v2/Modals/CreateAddClientModal';

import logger from 'itrvl-logger';
const log = logger(__filename);
log.trace(__filename);

const ClientMenuButton = () => {
  const userContext = useContext(UserContext);
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);

  const client = userContext.client;

  const showClientModal = () => {
    NiceModal.show(CreateAddClientModal, {
      canDelete: false,
      agencyId: userContext.agency.id,
      onSelectExistingClient: async (selectedClient, modal) => {
        await userContext.updateClient(selectedClient);
        modal.hide();
        history.push(`/clients/${selectedClient.id}`);
      },
      client: userContext.client,
      showCurrentClient: true,
    });
  };

  const handleClick = event => {
    if (client) {
      setAnchorEl(event.currentTarget);
    } else {
      showClientModal();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClientDetails = () => {
    handleClose();
    history.push(`/clients/${client.id}`);
  };

  const handleSwitchClient = () => {
    handleClose();
    showClientModal();
  };

  return (
    <>
      <Tooltip title={client ? client.name : 'Select Client'}>
        <IconButton onClick={handleClick} aria-label={client ? `Client: ${client.name}` : 'Select Client'} sx={{ color: 'white' }}>
          <Badge color="warning" variant="dot" invisible={!!client}>
            <ClientIcon color="white" />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableScrollLock
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList>
          {client?.name && [
            <MenuItem
              key="selected"
              disableRipple
              sx={{ '&:hover': { backgroundColor: 'transparent' }, cursor: 'default', flexDirection: 'column', alignItems: 'flex-start' }}
            >
              <Typography variant="caption" color="text.secondary">
                Selected:
              </Typography>
              {client.name}
            </MenuItem>,
            <Divider key="divider" />,
          ]}
          <MenuItem onClick={handleClientDetails}>Client Details</MenuItem>
          <MenuItem onClick={handleSwitchClient}>Switch Client</MenuItem>
        </MenuList>
      </Popover>
    </>
  );
};

export default ClientMenuButton;
